export class TableContextNote {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "date",
            "baseName": "date",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "edit",
            "baseName": "edit",
            "type": "TableContextEdit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextNote.attributeTypeMap;
    }
    constructor() {
    }
}
